module.exports = __webpack_public_path__ + "img/grgwjkxt3.2b345a8f.jpg";